import { apiAxios } from '../utils/axios';

export const GetNews = async () => {
  return await apiAxios.get('/news');
};
